import { Routes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";

// Public Pages
import Login from "./pages/Login";
import Callback from "./pages/Callback";
import Logout from "./pages/Logout";

// Protected Pages
import Dashboard from "./pages/Dashboard";
import Tools from "./pages/Tools";
import OrdersPage from "./pages/OrdersPage";
import IvrStatusAdminPage from "./pages/IVRStatusAdminPage";
import AccountPage from "./pages/Account";
import IvrChecker from "pages/IvrChecker";
import OrderUpdatesPage from "pages/OrderUpdatesPage";
import UnpaidOrdersPage from "pages/UnpaidOrdersPage";
import Agreements from "pages/Agreements";
import UnverifiedUsersPage from "pages/UnverifiedUsersPage";
import CRMTool from "pages/CRMTool";
import InvoicesPage from "pages/InvoicesPage";
import AdminUserList from "pages/AdminUserList";
import AdminBAAEditor from "pages/AdminBAAEditor";
import AdminCreateOrderPage from "pages/AdminCreateOrderPage";
import OrderSuccessPage from 'pages/OrderSuccessPage';
import AdminBAACreator from "pages/AdminBAACreator";
import RepDashboardPage from "pages/RepDashboardPage";
import AdminKanban from "pages/AdminKanban";
import CreateDistributorInvoice from "pages/CreateDistributorInvoice"
import FacilitiesManagementPage from "pages/FacilitiesManagementPage";
import AdminProducts from "pages/AdminProducts";
import CreateIVR from "pages/CreateIVR";
import NotificationsPage from "pages/NotificationsPage";
import AdminLogsPage from "pages/AdminLogsPage";
import ViewAsCustomerPage from "pages/ViewAsCustomerPage";

// Wrapper
import ProtectedRouteWithLayout from "components/ProtectedRouteWithLayout";
import AdminTreatmentOrdersPage from "pages/AdminTreatmentOrdersPage";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
  <Route path="/callback" element={<Callback />} />
  <Route path="/logout" element={<Logout />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRouteWithLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/ivrstatus" element={<IvrStatusAdminPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/tools/ivr-checker" element={<IvrChecker />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/tools/order-updates" element={<OrderUpdatesPage />} />
          <Route path="/tools/payment-reminders" element={<UnpaidOrdersPage />} />
          <Route path="/tools/agreements" element={<Agreements />} />
          <Route path="/tools/email-verification" element={<UnverifiedUsersPage />} />
          <Route path="*" element={<Dashboard />} />
          <Route path="/tools/crm" element={<CRMTool />} />
          <Route path="/tools/users" element={<AdminUserList />} />
          <Route path="/tools/users/:userId/edit-baa" element={<AdminBAAEditor />} />
          <Route path="/tools/create-order" element={<AdminCreateOrderPage />} />
          <Route path="/admin/create-order/:ivrId/:userId" element={<AdminCreateOrderPage />} />
          <Route path="/admin/order-success" element={<OrderSuccessPage />} />
          <Route path="/baa-creator" element={<AdminBAACreator />} />
          <Route path="/rep-dashboard" element={<RepDashboardPage />} />
          <Route path="/tools/kanban" element={<AdminKanban />} />
          <Route path="/admin/invoices/distributors/create" element={<CreateDistributorInvoice />} />
          <Route path="/admin/treatment-orders" element={<AdminTreatmentOrdersPage />} />
          <Route path="/tools/facilities-management" element={<FacilitiesManagementPage />} />
          <Route path="/tools/create-ivr" element={<CreateIVR />} />
          <Route path="/tools/products" element={<AdminProducts />} />
           <Route path="/tools/admin-logs" element={<AdminLogsPage />} />
           <Route path="/tools/view-as-customer" element={<ViewAsCustomerPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
